import React from 'react';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        textAlign: 'center',
        margin: theme.spacing.unit * 4,
    },
});

export class NotFound extends React.Component {
    render(){
        return (
            <div className={this.props.classes.root}>ページが見つかりません</div>
        );
    }
}

export default withStyles(styles)(NotFound);
